import React, { useState, useEffect } from 'react';
import { AI_COLORS, AI_FONTS } from '../shared';

const quizData = [
  {
    question: 'Quando é recomendado trocar a escova de dentes?',
    options: ['Uma vez por ano', 'A cada 3 meses ou quando estiver desgastada', 'Somente quando quebrar', 'A cada 6 meses'],
    answer: 1,
    dica: 'Escovas desgastadas perdem eficiência na limpeza dos dentes.',
  },
  {
    question: 'Sangramento durante a escovação é normal?',
    options: ['Sim, é sinal de escovação eficiente', 'Não', 'Apenas em idosos', 'Depende da escova'],
    answer: 1,
    dica: 'Sangramento pode indicar inflamação na gengiva (gengivite).',
  },
  {
    question: 'Posso utilizar pasta de dente com carvão ativado para escovar os dentes?',
    options: ['Sim, ela branqueia os dentes', 'Não', 'Apenas eventualmente', 'Sim, se indicada pelo dentista'],
    answer: 1,
    dica: 'Pasta com carvão ativado é proibida pois causa desgaste no esmalte dentário, levando à sensibilidade.',
  },
  {
    question: 'Quem usa dentadura precisa higienizar a boca?',
    options: ['Sim', 'Não, pois não tem dentes', 'Apenas a dentadura', 'Só a gengiva, não a dentadura'],
    answer: 0,
    dica: 'Mesmo sem dentes naturais, a boca precisa de cuidados diários.',
  },
  {
    question: 'Dentaduras devem ser higienizadas:',
    options: ['Apenas com água', 'Todos os dias, com água e detergente neutro', 'Apenas quando estiverem sujas', 'Uma vez por semana'],
    answer: 1,
    dica: 'A higiene diária ajuda a evitar infecções e problemas bucais.',
  },
  {
    question: 'Posso dormir com a dentadura (prótese) todos os dias, sem orientação profissional?',
    options: ['Sim, não há problema', 'Não', 'Apenas se for confortável', 'Somente à noite'],
    answer: 1,
    dica: 'Não é recomendado dormir com a dentadura. Em caso de dúvida, consulte o cirurgião dentista.',
  },
  {
    question: 'Pessoas com diabetes precisam ter atenção à saúde bucal?',
    options: ['Sim', 'Não, são problemas independentes', 'Apenas se tiver dor', 'Só se usar medicamentos'],
    answer: 0,
    dica: 'Diabetes e saúde bucal podem influenciar uma à outra — cuidar da boca ajuda no controle da doença.',
  },
  {
    question: 'Qual hábito ajuda a manter corpo e boca saudáveis?',
    options: ['Alimentação equilibrada e atividade física', 'Consumir muito açúcar diariamente', 'Fumar moderadamente', 'Evitar beber água'],
    answer: 0,
    dica: 'Hábitos saudáveis ajudam a prevenir doenças e manter a saúde geral.',
  },
  {
    question: 'Beber água pode ajudar a diminuir a sensação de boca seca?',
    options: ['Sim', 'Não', 'Apenas sucos ajudam', 'Só refrigerantes gelados'],
    answer: 0,
    dica: 'A hidratação ajuda no conforto e na saúde da boca.',
  },
  {
    question: 'Fumar pode aumentar o risco de doenças bucais?',
    options: ['Sim', 'Não, a boca é separada dos pulmões', 'Apenas o cigarro eletrônico', 'Somente em idosos'],
    answer: 0,
    dica: 'O tabagismo pode trazer diversos prejuízos à saúde bucal, incluindo câncer de boca.',
  },
];

function shuffleArray(arr) {
  return [...arr].sort(() => Math.random() - 0.5);
}

const resultados = [
  { min: 0, max: 2, emoji: '🙂', texto: 'Continue explorando o website. Cada novo aprendizado ajuda a melhorar os cuidados com a saúde bucal.' },
  { min: 3, max: 5, emoji: '👏', texto: 'Muito bem! Você já conhece alguns cuidados importantes para manter a saúde bucal.' },
  { min: 6, max: 8, emoji: '🌟', texto: 'Parabéns! Você demonstrou um bom conhecimento sobre saúde bucal e hábitos saudáveis.' },
  { min: 9, max: 10, emoji: '🏆', texto: 'Excelente! Você mostrou ótimo conhecimento sobre saúde bucal e está no caminho certo para manter um sorriso saudável.' },
];

export default function QuizAdultoIdosos() {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  useEffect(() => {
    setQuestions(shuffleArray(quizData));
  }, []);

  const handleSelect = (index) => {
    if (selected !== null) return;
    setSelected(index);
    if (index === questions[current].answer) setScore((s) => s + 1);
    setTimeout(() => {
      if (current + 1 < questions.length) {
        setCurrent((c) => c + 1);
        setSelected(null);
      } else {
        setGameOver(true);
      }
    }, 3500);
  };

  const restart = () => {
    setQuestions(shuffleArray(quizData));
    setCurrent(0);
    setSelected(null);
    setScore(0);
    setGameOver(false);
  };

  if (!questions.length)
    return <p style={{ paddingTop: 100, textAlign: 'center' }}>Carregando...</p>;

  if (gameOver) {
    const resultado = resultados.find((r) => score >= r.min && score <= r.max) || resultados[3];
    return (
      <div style={styles.wrap}>
        <div style={styles.card}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3.5rem', marginBottom: 8 }}>{resultado.emoji}</div>
            <h2
              style={{
                fontFamily: AI_FONTS.title,
                color: AI_COLORS.blue900,
                fontSize: '2rem',
                margin: '0 0 8px',
              }}
            >
              Quiz concluído!
            </h2>
            <div
              style={{
                fontSize: '3rem',
                fontWeight: 'bold',
                color: AI_COLORS.blue400,
                margin: '16px 0',
              }}
            >
              {score}/{questions.length}
            </div>
            <p style={{ lineHeight: 1.7, marginBottom: 24, color: AI_COLORS.textDark }}>
              {resultado.texto}
            </p>
            <button style={styles.btn} onClick={restart}>
              Jogar novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  const q = questions[current];
  return (
    <div style={styles.wrap}>
      <div style={{ maxWidth: 620, width: '100%' }}>
        <h2
          style={{
            fontFamily: AI_FONTS.title,
            color: AI_COLORS.blue900,
            fontSize: '1.5rem',
            marginBottom: 4,
            textAlign: 'center',
          }}
        >
          Quiz — Saúde Bucal
        </h2>
        <p style={{ color: AI_COLORS.textMuted, marginBottom: 20, textAlign: 'center' }}>
          Pergunta {current + 1} de {questions.length}
        </p>

        <div style={styles.progress}>
          <div
            style={{
              ...styles.progressBar,
              width: `${(current / questions.length) * 100}%`,
            }}
          />
        </div>

        <div style={{ ...styles.card, marginTop: 16 }}>
          <p style={styles.question}>{q.question}</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {q.options.map((opt, i) => {
              let bg = AI_COLORS.bgBlue50;
              let border = 'transparent';
              if (selected !== null) {
                if (i === q.answer) { bg = AI_COLORS.green50; border = '#4CAF50'; }
                else if (i === selected && i !== q.answer) { bg = '#FCE4EC'; border = '#EF9A9A'; }
              }
              return (
                <button
                  key={i}
                  style={{
                    ...styles.option,
                    backgroundColor: bg,
                    border: `2px solid ${border}`,
                  }}
                  onClick={() => handleSelect(i)}
                >
                  {opt}
                </button>
              );
            })}
          </div>

          {selected !== null && (
            <div
              style={{
                marginTop: 16,
                background: AI_COLORS.bgAmber50,
                borderLeft: `4px solid ${AI_COLORS.amber300}`,
                borderRadius: 8,
                padding: '12px 16px',
                fontSize: '0.9rem',
                lineHeight: 1.65,
              }}
            >
              💡 {q.dica}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #E3F2FD 0%, #B3E5FC 55%, #EDE7F6 100%)',
    padding: '80px 24px 120px',
    fontFamily: AI_FONTS.body,
  },
  card: {
    background: 'white',
    borderRadius: 16,
    padding: '28px 26px',
    maxWidth: 620,
    width: '100%',
    boxShadow: '0 6px 24px rgba(1,87,155,0.12)',
  },
  question: {
    fontSize: '1.1rem',
    fontWeight: 700,
    marginBottom: 20,
    color: AI_COLORS.textDark,
    lineHeight: 1.55,
    fontFamily: AI_FONTS.body,
  },
  option: {
    padding: '12px 16px',
    borderRadius: 10,
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '0.94rem',
    transition: 'background-color 0.2s',
    fontFamily: AI_FONTS.body,
    lineHeight: 1.5,
    color: AI_COLORS.textDark,
  },
  btn: {
    padding: '12px 36px',
    background: AI_COLORS.blue800,
    color: 'white',
    border: 'none',
    borderRadius: 10,
    fontSize: '1rem',
    cursor: 'pointer',
    fontWeight: 700,
    fontFamily: AI_FONTS.body,
  },
  progress: {
    width: '100%',
    height: 8,
    background: '#e0e0e0',
    borderRadius: 4,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    background: AI_COLORS.blue400,
    transition: 'width 0.4s ease',
  },
};
